<div class="flex flex-column gap-3">
  <div class="grid">
    @if(!isPwcPresumptive){
    <div class="col-6 lg:col flex flex-column">
      <span class="text-xs text-primary">Rate</span>
      <span class="text-sm font-medium">${{getFixedValueDigits(job?.role?.hourlyRate)}}/hr</span>
    </div>
    }
    @if(job.role.overTime){
    <div class="col-6 lg:col flex flex-column">
      <span class="text-xs text-primary">Overtime</span>
      @if(job?.role?.overTime){
      <span class="text-sm font-medium">${{job?.role?.overTime}}/hr</span>
      } @else {
      <span class="text-sm font-medium">N/A</span>
      }
    </div>
    }
    @if(job?.role?.workSchedule?.duration){
    <div class="col-6 lg:col flex flex-column">
        @if(isPWCEnabled){
            <span class="text-xs text-primary">Anticipated duration</span>
        }
        @else {
            <span class="text-xs text-primary">Duration</span>
        }
      <span class="text-sm font-medium">{{job?.role?.workSchedule?.duration}}</span>
    </div>
    }
    @if(job?.role?.workSchedule?.workHours){
    <div class="col-6 lg:col flex flex-column">
      <span class="text-xs text-primary">Hours</span>
      <span class="text-sm font-medium">{{job?.role?.workSchedule?.workHours}}</span>
    </div>
    }
    @if(!job.role.overTime){
      <div  class="col-6 lg:col flex flex-column">
        @if(isPWCEnabled){
          <span class="text-xs text-primary">Required hours</span>
        } @else {
          <span class="text-xs text-primary">Schedule</span>
        }
        @if(job?.role?.workSchedule?.schedule?.weekDays?.willWork){
          @if(isPWCEnabled){
            <span class="text-sm font-medium">M-F ({{ job?.role?.workSchedule?.schedule?.weekDays?.generalSelectedHour }})</span>
            @if(job?.role?.workSchedule?.schedule?.weekDays?.potentialWeekendHours){
              <span class="text-sm font-medium">Potential weekend hours</span>
            }
          } @else {
            <span class="text-sm font-medium">M-F (
              {{ job?.role?.workSchedule?.schedule?.weekDays?.time?.start?.hour.toString().padStart(2, '0') }}:{{ job?.role?.workSchedule?.schedule?.weekDays?.time?.start?.min.toString().padStart(2, '0') }}
              {{ job?.role?.workSchedule?.schedule?.weekDays?.time?.start?.meridiem }}
              --
              {{ job?.role?.workSchedule?.schedule?.weekDays?.time?.end?.hour.toString().padStart(2, '0') }}:{{ job?.role?.workSchedule?.schedule?.weekDays?.time?.end?.min.toString().padStart(2, '0') }}
              {{ job?.role?.workSchedule?.schedule?.weekDays?.time?.end?.meridiem }}
              )</span>
          }
        }
        @if(!isPWCEnabled && job?.role?.workSchedule?.schedule?.saturday?.willWork){
        <span class="text-sm font-medium">SAT (
          {{ job.role.workSchedule.schedule.saturday.time.start.hour.toString().padStart(2, '0') }}:{{ job.role.workSchedule.schedule.saturday.time.start.min.toString().padStart(2, '0') }}
          {{ job.role.workSchedule.schedule.saturday.time.start.meridiem }}
          --
          {{ job.role.workSchedule.schedule.saturday.time.end.hour.toString().padStart(2, '0') }}:{{ job.role.workSchedule.schedule.saturday.time.end.min.toString().padStart(2, '0') }}
          {{ job.role.workSchedule.schedule.saturday.time.end.meridiem }}
          )</span>
        }
        @if(!isPWCEnabled && job?.role?.workSchedule?.schedule?.sunday?.willWork){
        <span class="text-sm font-medium">SUN (
          {{ job.role.workSchedule.schedule.sunday.time.start.hour.toString().padStart(2, '0') }}:{{ job.role.workSchedule.schedule.sunday.time.start.min.toString().padStart(2, '0') }}
          {{ job.role.workSchedule.schedule.sunday.time.start.meridiem }}
          --
          {{ job.role.workSchedule.schedule.sunday.time.end.hour.toString().padStart(2, '0') }}:{{ job.role.workSchedule.schedule.sunday.time.end.min.toString().padStart(2, '0') }}
          {{ job.role.workSchedule.schedule.sunday.time.end.meridiem }}
          )</span>
        }
      </div>
    }
    @if(!job?.role?.workSchedule?.duration){
    <div class="col-6 lg:col flex flex-column"></div>
    }
    @if(!job?.role?.workSchedule?.workHours){
    <div class="col-6 lg:col flex flex-column"></div>
    }
    </div>
    <div class="grid">
        @if(!isPwcPresumptive){
        <div class="col-6 lg:col flex flex-column">
            <span class="text-xs text-primary">Qualification</span>
            @if(job.role?.degrees?.length){
                <span class="text-xs">Degrees</span>
                @for(degree of job.role.degrees; track degree){
                    <span class="text-sm font-medium">{{degree.major}}</span>
                }
            }
            @else {
                <span class="text-sm font-medium">N/A</span>
            }
        </div>
        }
        <div class="col-6 lg:col flex flex-column">
            @if(isPWCEnabled){
                <span class="text-xs text-primary">{{'Anticipated start Date' | sentenceCase}}</span>
            }
            @else {
                <span class="text-xs text-primary">{{'Start Date' | sentenceCase}}</span>
            }
            @if(job.isFuture){
                <span class="text-sm font-medium">{{(job.role.startDate | date:'MMM dd, YYYY') || 'Start date not finalized'}}</span>
                <span class="text-sm font-medium">@if(job.role.startTime){{{job.role.startTime}} - {{job.role.timezone}}}@else{}</span>
            }
            @else
            {
                <span class="text-sm font-medium">{{job.positionStartDate | date:'MMM dd, YYYY'}}</span>
                <span class="text-sm font-medium">{{job.positionStartDate | date:'hh:mm a'}} - {{job.role.timezone}}</span>
            }
        </div>
        <div class="col-6 lg:col flex flex-column">
            <span class="text-xs text-primary">Address</span>
            @if(job?.role?.reviewCenterLocation?.isRemote){
                <span class="text-sm font-medium">Remote</span>
            }
            @else{
                <div>
                    <div>
                        <span class="text-sm font-medium">{{jobLocation.officeName? jobLocation.officeName+',': ''}}</span><br>
                        <span class="text-sm font-medium">{{jobLocation.street}}</span>
                        @if(jobLocation?.suiteNo){
                            <span class="text-sm font-medium">{{', ' + jobLocation.suiteNo}}</span>
                        }
                        <br>
                        <span class="text-sm font-medium">{{jobLocation.city? jobLocation.city+', ': ''}}</span>
                        <span class="text-sm font-medium">
                            {{jobLocation.state? jobLocation.state +', ' : ''}}
                        </span>
                        <span class="text-sm font-medium">{{jobLocation.zipCode }}</span>
                    </div>
                </div>
            }
        </div>
        <div class="col-6 lg:col flex flex-column">
            @if(!isPWCEnabled)  {
                <span class="text-xs text-primary">Contact</span>
                <span class="text-sm font-medium">{{job.role.reviewCenterLocation.pointOfContact}}</span>
                <span class="text-sm font-medium">{{job.role.reviewCenterLocation.email}}</span>
                <span class="text-sm font-medium">{{getFormattedNumber(job.role.reviewCenterLocation.phoneNumber) }}</span>
            }
        </div>
    </div>
    @if(!isPwcPresumptive && (job.role?.criteriaTemplate?.length || job.role?.credentialTemplate?.length)){
        <div class="grid">
            @if(job.role?.criteriaTemplate?.length){
                <div class="col-6 lg:col flex flex-column">            
                    <span class="text-xs text-primary">Skills and Experience</span>
                    @for(skill of job.role.criteriaTemplate; track skill){
                        <span class="text-sm font-medium">{{skill.name}}</span>
                    }
                </div>
            }
            @if(job.role?.credentialTemplate?.length){
                <div class="col-6 lg:col flex flex-column">
                    <span class="text-xs text-primary">Credentials</span>
                    @for(cred of job.role.credentialTemplate; track cred){
                        <span class="text-sm font-medium">{{cred.name}}</span>
                    }
                </div>
            }
            <div class="col-6 lg:col flex flex-column">
            </div>
            <div class="col-6 lg:col flex flex-column">
            </div>
        </div>
    }
    <div class="grid">
        @if(job.role.overTime){
            <div class="col-6 lg:col flex flex-column">
                @if(isPWCEnabled){
                  <span class="text-xs text-primary">Required hours</span>
                } @else {
                  <span class="text-xs text-primary">Schedule</span>
                }
                @if(job?.role?.workSchedule?.schedule?.weekDays?.willWork){
                  @if(isPWCEnabled){
                    <span class="text-sm font-medium">M-F ({{ job?.role?.workSchedule?.schedule?.weekDays?.generalSelectedHour }})</span>
                    @if(job?.role?.workSchedule?.schedule?.weekDays?.potentialWeekendHours){
                      <span class="text-sm font-medium">Potential weekend hours</span>
                    }
                  } @else {
                    <span class="text-sm font-medium">M-F (
                        {{ job?.role?.workSchedule?.schedule?.weekDays?.time?.start?.hour.toString().padStart(2, '0') }}:{{ job?.role?.workSchedule?.schedule?.weekDays?.time?.start?.min.toString().padStart(2, '0') }}
                        {{ job?.role?.workSchedule?.schedule?.weekDays?.time?.start?.meridiem }}
                        --
                        {{ job?.role?.workSchedule?.schedule?.weekDays?.time?.end?.hour.toString().padStart(2, '0') }}:{{ job?.role?.workSchedule?.schedule?.weekDays?.time?.end?.min.toString().padStart(2, '0') }}
                        {{ job?.role?.workSchedule?.schedule?.weekDays?.time?.end?.meridiem }}
                        )</span>
                  }
                }
                @if(!isPWCEnabled && job?.role?.workSchedule?.schedule?.saturday?.willWork){
                <span class="text-sm font-medium">SAT (
                    {{ job.role.workSchedule.schedule.saturday.time.start.hour.toString().padStart(2, '0') }}:{{ job.role.workSchedule.schedule.saturday.time.start.min.toString().padStart(2, '0') }}
                    {{ job.role.workSchedule.schedule.saturday.time.start.meridiem }}
                    --
                    {{ job.role.workSchedule.schedule.saturday.time.end.hour.toString().padStart(2, '0') }}:{{ job.role.workSchedule.schedule.saturday.time.end.min.toString().padStart(2, '0') }}
                    {{ job.role.workSchedule.schedule.saturday.time.end.meridiem }}
                    )</span>
                }
                @if(!isPWCEnabled && job?.role?.workSchedule?.schedule?.sunday?.willWork){
                <span class="text-sm font-medium">SUN (
                    {{ job.role.workSchedule.schedule.sunday.time.start.hour.toString().padStart(2, '0') }}:{{ job.role.workSchedule.schedule.sunday.time.start.min.toString().padStart(2, '0') }}
                    {{ job.role.workSchedule.schedule.sunday.time.start.meridiem }}
                    --
                    {{ job.role.workSchedule.schedule.sunday.time.end.hour.toString().padStart(2, '0') }}:{{ job.role.workSchedule.schedule.sunday.time.end.min.toString().padStart(2, '0') }}
                    {{ job.role.workSchedule.schedule.sunday.time.end.meridiem }}
                    )</span>
                }
            </div>
        }
        
        <div class="col-6 lg:col flex flex-column">
            <span class="text-xs text-primary">Additional instructions</span>
            <span class="text-sm font-medium">{{job.role.reviewCenterLocation.instructions || 'N/A'}}</span>
        </div>
    </div>
</div>
